import dayjs from 'dayjs'
import { ref } from 'vue'
import { useAuthStore } from '@/store/authStore'
import ActivityNewDialog from '@/components/ActivityNewDialog.vue'
import { openDialog } from '@stroybrooke-business-tools/components'
import { fetchGetActivity, fetchQueryActivity } from '@/api/activity'
const activityId = ref()
/** * 0：活动通知弹框，1：活动参与成功通知弹框 */
const noticeType = ref()
const startTime = ref()
const endTime = ref()
export const useActivityNewCustomer = async (type?: string) => {
  const useStore = useAuthStore()
  const uInfo = useStore.getUser
  try {
    const res = await fetchGetActivity('newCustomer')
    const { code, data } = res || {}
    if (code !== 200 || !data) return
    activityId.value = data.id
    // 活动时间范围
    startTime.value = dayjs(data.startTime) // 起始时间
    endTime.value = dayjs(data.endTime) // 结束时间

    if (uInfo?.userId) {
      const res = await fetchQueryActivity(activityId.value)
      const { code, data } = res || {}
      if (code !== 200 || !data) return
      noticeType.value = data.noticeType
      // 是否弹活动弹窗
      if (!data.isJump) return
      openDialog(ActivityNewDialog, {
        activityId: activityId.value,
        noticeType: noticeType.value,
      })
    } else {
      if (!uInfo?.username) return
      if (!endTime.value) return
      const now = dayjs()
      // 判断当前时间是否在活动范围内
      if (now.isAfter(startTime.value) && now.isBefore(endTime.value)) {
        openDialog(ActivityNewDialog)
      }
    }
  } catch (error) {
    console.log('useActivityNewCustomer执行报错->', error)
  }
}
